import dayjs from "dayjs";

export function normalizeYear({ year }) {
  return {
    ...year,
    from: dayjs(year.from).format("YYYY-MM-DD"),
    to: dayjs(year.to).format("YYYY-MM-DD"),
  };
}
